<template>
  <div class="home-box">
    <el-form :inline="true" :model="form" class="demo-form-inline">
      <el-form-item label="时间">
        <el-date-picker
          v-model="form.date"
          type="daterange"
          range-separator="至"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" @click="onSubmit">查询</el-button>
        <el-button @click="exportToExcel">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="tableData">
      <el-table-column type="index" width="60" />
      <el-table-column label="ID" prop="id" width="100" />
      <el-table-column label="标题" prop="title" min-width="280" show-overflow-tooltip />
      <el-table-column label="时间" prop="publishTimeText" width="170" />
      <el-table-column label="来源" prop="befrom" width="200" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.befrom || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="媒体号" prop="mediaAccountName" width="120" show-overflow-tooltip />
      <el-table-column label="编辑" prop="editorName" width="100" />
      <el-table-column label="阅读量" prop="pv" width="90" />
      <el-table-column label="链接" min-width="240">
        <template #default="{ row }">
          <a :href="row.titleurl" target="_blank">{{ row.titleurl }}</a>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { saveAs } from 'file-saver';
import { ref } from 'vue';
import * as XLSX from 'xlsx';

let tableData = ref([]);
let loading = ref(false);
let form = ref({
  date: '',
});
// 原始数据
const originalData = ref([]);

const pad = (n) => String(n).padStart(2, '0');
const formatTime = (ts) => {
  if (!ts) return '';
  const d = new Date(ts * 1000);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(
    d.getHours()
  )}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

// newsPath 形如 /8/news/170/2026-08-21/6203953.html，PC链接需去掉开头的租户号
const getDetailPath = (item) => {
  if (item.newsPath) return item.newsPath.replace(/^\/\d+\//, '/');
  const d = new Date(item.publishDate * 1000);
  return `/news/${item.columnId}/${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate()
  )}/${item.id}.html`;
};

const init = () => {
  loading.value = true;
  // wap端列表接口直接返回 befrom（来源）字段，无需再请求详情接口
  fetch(`/wapapi/api/v1/newsListChannel?page=1&channelId=24&pageSize=500`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((resp) => resp.json())
    .then((json) => {
      // 返回区块数组，文章在区块的 data 对象或 list 数组中
      const blocks = (json.data && json.data.list) || [];
      const list = [];
      blocks.forEach((block) => {
        if (block.data) list.push(block.data);
        if (Array.isArray(block.list)) list.push(...block.list);
      });
      // 过滤栏目/标签等非新闻块（id=0），并按 id 去重
      const seen = new Set();
      const validList = list.filter((item) => {
        if (!item.id || !item.publishDate || seen.has(item.id)) return false;
        seen.add(item.id);
        return true;
      });
      validList.forEach((item) => {
        item.titleurl = `https://www.cqcb.com${getDetailPath(item)}`;
        item.publishTimeText = formatTime(item.publishDate);
      });
      validList.sort((a, b) => b.publishDate - a.publishDate);
      originalData.value = validList;
      tableData.value = [...originalData.value];
    })
    .finally(() => {
      loading.value = false;
    });
};

const onSubmit = () => {
  if (!form.value.date || !form.value.date.length) {
    tableData.value = [...originalData.value];
    return;
  }
  const start = new Date(`${form.value.date[0]}T00:00:00`);
  const end = new Date(`${form.value.date[1]}T00:00:00`);
  end.setHours(23, 59, 59, 999);

  // 始终从原始数据筛选
  tableData.value = originalData.value
    .filter((item) => {
      const itemDate = new Date(item.publishDate * 1000);
      return itemDate >= start && itemDate <= end;
    })
    .sort((a, b) => a.publishDate - b.publishDate);
};

const exportToExcel = () => {
  const dataWithHeader = tableData.value.map((item) => ({
    标题: item.title,
    链接: item.titleurl,
    来源: item.befrom,
    时间: item.publishTimeText,
    媒体号: item.mediaAccountName,
    编辑: item.editorName,
    阅读量: item.pv,
  }));
  // 创建工作表
  const ws = XLSX.utils.json_to_sheet(dataWithHeader);

  // 创建工作簿
  const wb = XLSX.utils.book_new();

  // 将工作表添加到工作簿
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  // 导出Excel文件
  const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  // 使用FileSaver保存文件
  saveAs(
    new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
    '数据导出.xlsx'
  );
};
init();
</script>

<style>
.home-box {
  padding: 20px;
  box-sizing: border-box;
}
</style>
